export const DATE_TIME_DISPLAY_FORMAT = 'MM/dd/yyyy HH:mm';

export const getMenderDomainUrl = (menderSsoGuid: string) =>
  `https://hosted.mender.io/api/management/v1/useradm/auth/sso/${menderSsoGuid}/login`;

export const PEP_EMAIL_DOMAIN_PEPSICO = 'pepsico.com';
export const PEP_EMAIL_DOMAIN_PEPSICORPTST = 'pepsicorptst.com';
export const PEP_EMAIL_DOMAIN_CORPPEPTST = 'corp.pep.tst';
export const PEP_PLATFORM_SERVICES_URL =
  'https://secure.ite.pepsico.com/app/UserHome';
